export default function() {
    const slideInImg = document.querySelectorAll("[data-plugin='fadeinanimation']");

    if (slideInImg.length > 0) {
        // IntersectionObserver to trigger animation when the element comes into view
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('slide-in');
                        observer.unobserve(entry.target); // Stop observing once the animation is triggered
                    }
                });
            },
            {
                rootMargin: '0px 0px -200px 0px' // Adjust this for when the animation should start
            }
        );

        slideInImg.forEach(div => {
            observer.observe(div);
        });
    }
}
